module.exports = __webpack_public_path__ + "img/checkout-qr.eb06843.png";